import React, { useEffect, useState, useContext } from 'react';
import PathCard from '../../components/pathCard/PathCard';
import './FollowedPath.css'
import Floatbar from '../../components/floatbar/Floatbar';
import AuthContext from '../../contexts/AuthContext';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { Link } from 'react-router-dom';
import { FaRoad } from 'react-icons/fa';
import IconHeading from '../../components/sectionHeading/IconHeading';
import DropdownMenu from '../../components/dropdownMenu/DropdownMenu';

export function FollowedPath() {

    const { user } = useContext(AuthContext);

    const [pathData, setPathData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [sortOrder, setSortOrder] = useState("latest"); 

    const sortOptions = [
        { value: 'latest', label: 'Latest to Earliest' },
        { value: 'earliest', label: 'Earliest to Latest' },
    ];

    const getFollowedPath = async () => {
        setLoading(true);

        try {
            if (user.followedPath.length === 0) {
                setPathData([]);
                return;
            }

            const pathIds = user.followedPath.map(topic => topic.pathId);

            const response = await fetch('/api/path/getPaths', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ pathIds: pathIds })
            });

            if (response.ok) {
                const res = await response.json();

                const followedAtByPathId = user.followedPath.reduce((lookup, item) => {
                    lookup[item.pathId] = item.createdAt;
                    return lookup;
                }, {});

                const newFollowedPaths = res.data.map(bItem => {
                    return {
                        ...bItem,
                        followedAt: followedAtByPathId[bItem.pathId]
                    };
                });

                newFollowedPaths.sort((a, b) => {
                    if (sortOrder === 'latest') {
                        return new Date(b.followedAt) - new Date(a.followedAt);
                    } else {
                        return new Date(a.followedAt) - new Date(b.followedAt);
                    }
                });

                setPathData(newFollowedPaths);
            }
        } catch (e) {

        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        getFollowedPath();
    }, [user.followedPath, sortOrder]);

    const handleSortChange = (value) => {
        setSortOrder(value); 
        setPathData(null);    
    };

    return (
        <div id="content-container">
            <IconHeading icon={FaRoad} title="Followed Path" headingSize="medium" />

            <hr />
            <div className="inline-block-wrapper margin-top-30">
                <div style={{ width: '100%' }}>
                    <DropdownMenu
                        label=""
                        options={sortOptions}
                        selectedValue={sortOrder}
                        onOptionSelect={handleSortChange}
                    />
                    <div className="path-card-deck margin-top-30 margin-btm-30">
                        {!loading
                            ? (pathData?.length > 0
                                ? pathData.map((path, index) => (
                                    <Link to={`/home?path=${path.pathId}`} key={index} className="underline-disable">
                                        <PathCard
                                            key={index}
                                            pathId={path.pathId}
                                            pathName={path.pathName}
                                            followers={path.follower}
                                            description={path.description}
                                        />
                                    </Link>
                                ))
                                : <h3 className="empty-state">No Followed Path...Yet</h3>
                            )
                            : <Skeleton count={3} width={200} />
                        }
                    </div>
                </div>
                <Floatbar />
            </div>
        </div>
        );
}